import { isNil } from "lodash";
import moment from "moment";

import { type User } from "@internal/user";
import {
  type BenchmarkAttributionWindowEnum,
  BenchmarkTypeEnum,
} from "@north-beam/nb-client-side";
import { emptyText, Currencies } from "@north-beam/nb-common";

import { BenchmarkAttributionWindowValues } from "./constants";

export const getDollarValue = (
  value: number | null | undefined,
  user: User,
) => {
  return !isNil(value)
    ? `${
        Currencies.getModel(user.currencies.currentCurrency).symbol
      }${value.toFixed(2)}`
    : emptyText;
};

export const getDecimalValue = (value: number | null | undefined) => {
  return !isNil(value) ? `${value.toFixed(2)}` : emptyText;
};

export const getPrettyBenchmark = (
  benchmarkType: BenchmarkTypeEnum,
  value: number | null | undefined,
  user: User,
) => {
  if (benchmarkType === BenchmarkTypeEnum.CAC) {
    return getDollarValue(value, user);
  }
  return `${getDecimalValue(value)}`;
};
